<div>
<nx-pageTitle-box
  [label]="tenant?.name"
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'/settings'"
  [bcRootLvl1Label]="'Tenants'"
  [bcRootLvl1Path]="'/settings/tenants'"
  [icon]="'icon-tenant'"
  [iconToolTip]="'Tenant'">
  <ng-template nxTemplate="end">
    <nx-default-button
      class="mr-2"
      (click)="editTenant()"
      [tooltip]="'Tenant bearbeiten'"
      [style]="'transparent'"
      [icon]="'icon-edit'">
    </nx-default-button>

    <nx-default-button
      (click)="switchTenant()"
      [label]="'wechseln'"
      [tooltip]="'Zu Tenant wechseln'"
      [style]="'transparent'"
      icon="icon icon-switch">
    </nx-default-button>

  </ng-template>
</nx-pageTitle-box>

<div class="flex flex-row gap-4 mt-2">
  <div
    class="basis-1/2">
    <nx-headline-box  
      [label]="'Tenantdaten'">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Name'">
      {{tenant?.name}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Zusätzlicher Name'">
      {{tenant?.additionalName}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Beschreibung'">
      {{tenant?.description}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Nexato interner Tenant'">
      <p-checkbox
        [disabled]="true"
        [binary]="true"
        [ngModel]="tenant?.isNexatoTenant">
      </p-checkbox>
    </nx-default-box>
    <nx-headline-box  
      class="mt-2"
    [label]="'Steuerinformationen'">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Steuer-ID Typ'">
      {{getVatType(tenant?.vatType)}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Umsatzsteuer-Identifikationsnummer'">
      {{tenant?.vatNumber}}
    </nx-default-box>
    <nx-headline-box  
      class="mt-2"
      [label]="'Zahlungsanbieterintegration'">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Aktiviert'">
      <p-checkbox
        [disabled]="true"
        [binary]="true"
        [ngModel]="tenant?.paymentProviderEnabled">
      </p-checkbox>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Zahlungsanbieter-Id'">
      {{tenant?.paymentProviderId}}
    </nx-default-box>
  </div>
  <div
    class="basis-1/2">
    <nx-headline-box  
      [label]="'Anschrift'">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Addresszeile 1'">
      {{tenant?.addressLine0}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Addresszeile 2'">
      {{tenant?.addressLine1}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Postleitzahl'">
      {{tenant?.postalCode}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Stadt'">
      {{tenant?.city}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Land'">
      {{tenant?.country}}
    </nx-default-box>

    <nx-headline-box
      class="mt-2"
      [label]="'Kontaktdaten'">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'E-Mail'">
      {{tenant?.email}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Telefon'">
      {{tenant?.phone}}
    </nx-default-box> 
  </div>
</div>

